import React from "react";

const AboutUs = () => {
  return (
    <>
      <div className="bg-white py-20 px-4 mt-[86px] sm:px-8 lg:px-12 border-t border-fuchsia-200 rounded">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-xl sm:text-5xl font-bold text-violet-600 mb-6">
            Preventive Pulse Healthcare Private Limited
          </h2>
          <p className="text-base sm:text-lg text-slate-600 leading-relaxed max-w-4xl mx-auto mb-12">
            Preventive Pulse Healthcare Private Limited is dedicated to making
            preventive and outpatient healthcare more accessible, affordable, and
            proactive. With a mission to bridge the gap between patients and quality
            care, we provide comprehensive OPD plans, digital consultations, and
            continuous wellness support tailored for every individual and family.
          </p>
        </div>
      </div>
      <div className=" bg-gradient-to-br from-slate-100 to-violet-100  ">
        <div className="p-4 sm:p-8 flex items-center justify-center">
          <div className="max-w-6xl w-full  rounded-lg  overflow-hidden md:flex">
            <div className="flex-1 p-6 sm:p-10 lg:p-12 space-y-6 flex flex-col justify-center">
              <h2 className="text-sm sm:text-base font-bold text-slate-900 uppercase tracking-wider">
                YOUR COMPLETE HEALTH AND WELLNESS SUPPORT
              </h2>
              <h1 className="text-4xl sm:text-5xl font-bold text-violet-500 leading-tight">
                About Us
              </h1>
              <ul className="space-y-3">
                <li className="flex items-center text-slate-900 text-base sm:text-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check text-violet-600 w-5 h-5 mr-2 flex-shrink-0 rounded-full  p-0.5"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span className="text-slate-700 text-lg">
                    Unlimited Doctor Access
                  </span>
                </li>
                <li className="flex items-center text-slate-900 text-base sm:text-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check text-violet-600 w-5 h-5 mr-2 flex-shrink-0 rounded-full  p-0.5"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span className="text-slate-700 text-lg">
                    Annual Health Check-ups
                  </span>
                </li>
                <li className="flex items-center text-slate-900 text-base sm:text-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check text-violet-600 w-5 h-5 mr-2 flex-shrink-0 rounded-full  p-0.5"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span className="text-slate-700 text-lg">
                    Mental Wellness Support
                  </span>
                </li>
                <li className="flex items-center text-slate-900 text-base sm:text-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check text-violet-600 w-5 h-5 mr-2 flex-shrink-0 rounded-full  p-0.5"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span className="text-slate-700 text-lg">
                    Personalized Nutrition Guidance
                  </span>
                </li>
                <li className="flex items-center text-slate-900 text-base sm:text-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check text-violet-600 w-5 h-5 mr-2 flex-shrink-0 rounded-full  p-0.5"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span className="text-slate-700 text-lg">
                    Eye &amp; Dental Care
                  </span>
                </li>
                <li className="flex items-center text-slate-900 text-base sm:text-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check text-violet-600 w-5 h-5 mr-2 flex-shrink-0 rounded-full  p-0.5"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span className="text-slate-700 text-lg">
                    Big Discounts on Health Essentials
                  </span>
                </li>
              </ul>
              <button className="mt-6 px-8 py-3 bg-violet-500 text-white font-bold rounded-md border-2 border-violet-500 hover:bg-transparent hover:text-violet-600 transition duration-300">
                Explore Our Plans
              </button>
            </div>
            <div className="relative flex-1 p-6 ism:p-10 lg:p-12 flex items-center justify-center overflow-hidden">
              <div className="relative animationTransform">
                <div className="absolute left-3 -top-2 bg-lime-500 text-white text-sm px-4 py-2 rounded-lg shadow-md">
                  <ul className="space-y-1">
                    <li className="flex items-center gap-2">
                      ✅ Unlimited Doctor Access
                    </li>
                    <li className="flex items-center gap-2">
                      ✅ Annual Health Check-ups
                    </li>
                    <li className="flex items-center gap-2">
                      ✅ Mental Wellness Support
                    </li>
                  </ul>
                </div>
                <div className="bg-gradient-to-br from-slate-600 to-violet-500 p-[4px] rounded-full">
                  <div className="bg-white rounded-full w-[300px] h-[300px] sm:w-[340px] sm:h-[340px] md:w-[380px] md:h-[380px] flex items-center justify-center overflow-hidden">
                    <img
                      src="assets/img/all-images/about-us.png"
                      alt="Family Health Plan"
                      className="w-full h-full object-cover rounded-full"
                    />
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 bg-cyan-900 text-white text-sm px-4 py-2 rounded-lg shadow-md">
                  <ul className="space-y-1">
                    <li className="flex items-center gap-2">
                      ✅ Personalized Nutrition Guidance
                    </li>
                    <li className="flex items-center gap-2">
                      ✅ Eye &amp; Dental Care
                    </li>
                    <li className="flex items-center gap-2">
                      ✅ Big Discounts on Health Essentials
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 flex items-center justify-center p-4 sm:p-6 lg:p-8">
          <div className="bg-white rounded-3xl shadow-sm sm:shadow-lg border border-fuchsia-300 p-6 sm:p-8 lg:p-10 max-w-6xl w-full">
            <div className="flex flex-col md:flex-row items-stretch justify-between gap-6">
              <div className="flex-1 flex flex-col justify-center p-4 sm:p-6 group hover:cursor-pointer">
                <div className="mb-4 sm:mb-6">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth={0}
                    viewBox="0 0 576 512"
                    className="w-10 h-10 text-violet-500"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"></path>
                  </svg>
                </div>
                <h2 className="text-2xl sm:text-3xl font-semibold text-slate-500 group-hover:text-violet-600 mb-3 sm:mb-4 transition-colors duration-300">
                  Our Vision
                </h2>
                <p className="text-slate-600 leading-relaxed text-base sm:text-lg">
                  At Magma OPD, our vision is to revolutionize outpatient care by
                  making quality medical consultations accessible and seamless for
                  every individual. We envision a future where health services are
                  just a click away, delivered with compassion and care.
                </p>
              </div>
              <div className="flex items-center justify-center">
                <div className="h-px w-5/6 bg-fuchsia-400 md:h-5/6 md:w-px" />
              </div>
              <div className="flex-1 flex flex-col justify-center p-4 sm:p-6 group hover:cursor-pointer">
                <div className="mb-4 sm:mb-6">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth={0}
                    viewBox="0 0 512 512"
                    className="w-10 h-10 text-violet-500"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2l0 82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-107.2c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"></path>
                  </svg>
                </div>
                <h2 className="text-2xl sm:text-3xl font-semibold text-slate-500 group-hover:text-violet-600 mb-3 sm:mb-4 transition-colors duration-300">
                  Our Mission
                </h2>
                <p className="text-slate-600 leading-relaxed text-base sm:text-lg">
                  Magma OPD is on a mission to provide fast, affordable, and
                  reliable outpatient healthcare services. We aim to bridge the gap
                  between patients and doctors by offering easy appointment booking,
                  expert consultations, and a smooth healthcare experience across
                  all touchpoints.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="min-h-screen py-10 bg-gradient-to-br from-slate-100 to-violet-100 flex flex-col items-center  px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl w-full">
            <h1 className="text-5xl mb-2 font-bold text-violet-500 relative">
              Why Choose Us
            </h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 my-10">
              <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-2xl border border-fuchsia-300 flex flex-col items-center text-center transition-shadow duration-300">
                <div className="p-3 rounded-full mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-headset w-8 h-8 text-violet-600"
                    aria-hidden="true"
                  >
                    <path d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z"></path>
                    <path d="M21 16v2a4 4 0 0 1-4 4h-5" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-fuchsia-500 mb-2">
                  Convenient Online Access
                </h3>
                <p className="text-slate-700 leading-relaxed">
                  Enjoy the flexibility of managing your healthcare from the comfort
                  of your home, with access to services via our easy-to-use online
                  platform, anytime and anywhere.
                </p>
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-2xl border border-fuchsia-300 flex flex-col items-center text-center transition-shadow duration-300">
                <div className="p-3 rounded-full mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-users w-8 h-8 text-violet-600"
                    aria-hidden="true"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <circle cx={9} cy={7} r={4} />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-fuchsia-500 mb-2">
                  Personalized Wellness Management
                </h3>
                <p className="text-slate-700 leading-relaxed">
                  With a dedicated wellness manager, you receive continuous support
                  and guidance, ensuring all your health needs are addressed
                  promptly and efficiently.
                </p>
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-2xl border border-fuchsia-300 flex flex-col items-center text-center transition-shadow duration-300">
                <div className="p-3 rounded-full mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-stethoscope w-8 h-8 text-violet-600"
                    aria-hidden="true"
                  >
                    <path d="M11 2v2" />
                    <path d="M5 2v2" />
                    <path d="M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1" />
                    <path d="M8 15a6 6 0 0 0 12 0v-3" />
                    <circle cx={20} cy={10} r={2} />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-fuchsia-500 mb-2">
                  Exclusive Discounts on Medicines &amp; Diagnostics
                </h3>
                <p className="text-slate-700 leading-relaxed">
                  Save on lab tests and medications with discounts of up to 40% on
                  diagnostics and 25% off branded medicines, making healthcare more
                  affordable.
                </p>
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-2xl border border-fuchsia-300 flex flex-col items-center text-center transition-shadow duration-300">
                <div className="p-3 rounded-full mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-shield-check w-8 h-8 text-violet-600"
                    aria-hidden="true"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12 2 2 4-4" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-fuchsia-500 mb-2">
                  Comprehensive Health Coverage
                </h3>
                <p className="text-slate-700 leading-relaxed">
                  From annual health check-ups to specialist consultations, we
                  provide a wide range of services that ensure complete healthcare
                  protection for all members of your family.
                </p>
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-2xl border border-fuchsia-300 flex flex-col items-center text-center transition-shadow duration-300">
                <div className="p-3 rounded-full mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-heart-pulse w-8 h-8 text-violet-600"
                    aria-hidden="true"
                  >
                    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                    <path d="M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-fuchsia-500 mb-2">
                  Tailored Healthcare Plans
                </h3>
                <p className="text-slate-700 leading-relaxed">
                  Our plans are designed to meet the unique needs of you and your
                  family, ensuring personalized coverage that adapts to your
                  lifestyle and health requirements.
                </p>
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-2xl border border-fuchsia-300 flex flex-col items-center text-center transition-shadow duration-300">
                <div className="p-3 rounded-full mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-briefcase-medical w-8 h-8 text-violet-600"
                    aria-hidden="true"
                  >
                    <path d="M12 11v4" />
                    <path d="M14 13h-4" />
                    <path d="M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
                    <path d="M18 6v14" />
                    <path d="M6 6v14" />
                    <rect width={20} height={14} x={2} y={6} rx={2} />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-fuchsia-500 mb-2">
                  Unlimited Access to Healthcare Professionals
                </h3>
                <p className="text-slate-700 leading-relaxed">
                  With unlimited teleconsultations, you can connect with doctors
                  from various specialties anytime, offering convenience and peace
                  of mind whenever you need medical advice.
                </p>
              </div>
            </div>
          </div>
        </div>
       
       {/*===== FREQUENTLY ASKED AREA ENDS =======*/}
      <section className="bg-white py-12 md:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 font-sans">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div className="relative flex flex-col items-center justify-center min-h-[300px] lg:min-h-[500px] xl:min-h-[600px] p-4">
            <h2 className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold text-gray-200 opacity-70 whitespace-nowrap z-0 select-none">
              Frequently <br /> Ask Question
            </h2>
            <img
              src="assets/img/all-images/faq-DGIcXqFE.avif"
              alt="FAQ illustration"
              className="relative max-w-full h-auto object-contain"
            />
            <div className="relative w-full h-full flex items-center justify-center" />
          </div>
          <div className="flex flex-col">
            <div className="mb-8">
              <h3 className="text-sm font-bold text-slate-700 uppercase tracking-wider">
                FAQ's
              </h3>
              <h2 className="text-3xl md:text-4xl font-extrabold text-violet-600 italic leading-tight mt-2">
                How we can support your healthcare journey
              </h2>
            </div>
            <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                       What is the coverage included in Magma OPD plans?
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Each plan offers a range of benefits such as discounts on diagnostic tests, free health check-ups, eye and dental benefits, mental wellness support, and emergency room coverage. The extent of the coverage depends on the selected plan.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        How do I choose the best plan for me?
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Choosing the best plan depends on your individual healthcare needs, budget, and desired coverage. We recommend reviewing the detailed plan descriptions on our website or contacting our support team for personalized assistance.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                       Are mental wellness services covered?
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Yes, many of our Magma OPD plans include coverage for mental wellness services, including therapy sessions, counseling, and psychiatric consultations. Please check your specific plan details for more information.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                       Do the plans include discounts on medicines?
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Absolutely! Several Magma OPD plans offer discounts on prescribed medicines at our network pharmacies. This is designed to help make your healthcare more affordable.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                       What is the process to enroll in a plan?
                      </button>
                    </h2>
                    <div
                      id="collapseFive"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Enrolling in an Magma OPD plan is simple. You can visit our website, select your desired plan, fill out the online application form, and complete the payment process. Our team will then reach out to confirm your enrollment.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                      Are there any age restrictions for the plans?
                      </button>
                    </h2>
                    <div
                      id="collapseSix"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Magma OPD plans are designed to cater to a wide range of age groups. While some plans may have specific age-related features, most are available to individuals and families of all ages. Please refer to individual plan details for any restrictions.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSeven"
                        aria-expanded="false"
                        aria-controls="collapseSeven"
                      >
                      Can I switch between plans after enrolling?
                      </button>
                    </h2>
                    <div
                      id="collapseSeven"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Yes, in most cases, you can switch between Magma OPD plans. There might be specific terms and conditions, such as a waiting period or a small administrative fee, associated with plan changes. Contact our customer service for guidance on switching plans.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </section>
      {/*===== FREQUENTLY ASKED ENDS =======*/}
      </div>

    </>
  );
};

export default AboutUs;
